import NAME from "./constants";

export const RESET_STATE = NAME + "/RESET_STATE";

export const GET = NAME + "/GET";
export const GET_REJECTED = NAME + "/GET_REJECTED";
export const GET_FULFILLED = NAME + "/GET_FULFILLED";

export const DELETE = NAME + "/DELETE";
export const DELETE_REJECTED = NAME + "/DELETE_REJECTED";
export const DELETE_FULFILLED = NAME + "/DELETE_FULFILLED";

export const CREATE = NAME + "/CREATE";
export const CREATE_REJECTED = NAME + "/CREATE_REJECTED";
export const CREATE_FULFILLED = NAME + "/CREATE_FULFILLED";

export const MODIFY = NAME + "/MODIFY";
export const MODIFY_REJECTED = NAME + "/MODIFY_REJECTED";
export const MODIFY_FULFILLED = NAME + "/MODIFY_FULFILLED";

export const PREVIEW = NAME + "/PREVIEW";
export const PREVIEW_REJECTED = NAME + "/PREVIEW_REJECTED";
export const PREVIEW_FULFILLED = NAME + "/PREVIEW_FULFILLED";

export const UPLOAD_DOCUMENT = NAME + "/UPLOAD_DOCUMENT";
export const UPLOAD_DOCUMENT_REJECTED = NAME + "/UPLOAD_DOCUMENT_REJECTED";
export const UPLOAD_DOCUMENT_FULFILLED = NAME + "/UPLOAD_DOCUMENT_FULFILLED";

export const DOWNLOAD_DOCUMENT = NAME + "/DOWNLOAD_DOCUMENT";
export const DOWNLOAD_DOCUMENT_REJECTED = NAME + "/DOWNLOAD_DOCUMENT_REJECTED";
export const DOWNLOAD_DOCUMENT_FULFILLED = NAME + "/DOWNLOAD_DOCUMENT_FULFILLED";

